import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, Spinner, EmptyState } from "@/components/site/Bits";

export const Policies = () => {
  const [items, setItems] = useState<any[] | null>(null);
  useEffect(() => {
    api.get("/policies").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <div>
      <PageHeader eyebrow="Legal & trust" title="Terms and Policies" intro="Please review the policies that apply to your request." />
      <div className="container-x grid gap-4 py-14 sm:grid-cols-2 lg:grid-cols-3">
        {!items ? <Spinner /> : items.map((p) => (
          <Link key={p.slug} to={`/policies/${p.slug}`} className="card-lux group flex items-center justify-between p-6 transition-transform hover:-translate-y-0.5" data-testid={`policy-link-${p.slug}`}>
            <div><h2 className="font-sans text-base font-semibold">{p.title}</h2><p className="mt-1 text-xs text-navy/50">Updated {fmtDate(p.updated_at)}</p></div>
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export const PolicyDetail = () => {
  const { slug } = useParams();
  const [p, setP] = useState<any>(null);
  useEffect(() => {
    setP(null);
    api.get(`/policies/${slug}`).then((r) => setP(r.data)).catch(() => setP(false));
  }, [slug]);
  if (p === null) return <Spinner />;
  if (!p) return <div className="container-x py-20"><EmptyState title="Policy not found" body="This policy is not published." cta="All policies" to="/policies" /></div>;
  return (
    <div>
      <PageHeader eyebrow={`Last updated ${fmtDate(p.updated_at)}`} title={p.title} testid="policy-title" />
      <article className="container-x max-w-3xl py-14 prose-policy" data-testid="policy-content">
        {String(p.content).split(/\n\s*\n/).map((para: string, i: number) => <p key={i} className="whitespace-pre-line">{para}</p>)}
        <Link to="/policies" className="btn-ghost mt-6">All policies</Link>
      </article>
    </div>
  );
};
